import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";

const MobileBottomBar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isSmallMobile = useMediaQuery("(max-width:360px)");

  if (!isMobile) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1400,
        px: isSmallMobile ? 1.5 : 2,
        pb: isSmallMobile ? 1.5 : 2,
        pt: 1.2,
        background:
          "linear-gradient(180deg, rgba(246,247,235,0.85) 0%, #F6F7EB 40%)",
        backdropFilter: "blur(12px)",
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        boxShadow: "0 -10px 30px rgba(0,0,0,0.18)",
      }}
    >
      <Typography
        variant="caption"
        sx={{
          textAlign: "center",
          mb: isSmallMobile ? 0.5 : 1,
          display: "block",
          fontSize: isSmallMobile ? "0.65rem" : "0.75rem",
          color: "var(--color-midnight-70)",
        }}
      >
        Estimate your project cost instantly
      </Typography>

      <Box sx={{ display: "flex", gap: isSmallMobile ? 0.8 : 1.2 }}>
        <Button
          fullWidth
          variant="outlined"
          startIcon={
            <SupportAgentOutlinedIcon
              sx={{ fontSize: isSmallMobile ? 18 : 20 }}
            />
          }
          onClick={() => window.open("https://wa.me/919532119007", "_blank")}
          sx={{
            height: isSmallMobile ? 44 : 52,
            fontSize: isSmallMobile ? "0.75rem" : "0.875rem",
            px: isSmallMobile ? 1 : 2,
          }}
        >
          Talk to Expert
        </Button>

        <Button
          fullWidth
          variant="contained"
          color="secondary"
          startIcon={
            <CalculateOutlinedIcon sx={{ fontSize: isSmallMobile ? 18 : 20 }} />
          }
          onClick={() =>
            document
              .getElementById("estimator")
              ?.scrollIntoView({ behavior: "smooth" })
          }
          sx={{
            height: isSmallMobile ? 44 : 52,
            fontSize: isSmallMobile ? "0.75rem" : "0.875rem",
            px: isSmallMobile ? 1 : 2,
          }}
        >
          Get Estimate
        </Button>
      </Box>
    </Box>
  );
};

export default MobileBottomBar;
